import { Mesh, MeshBasicMaterial } from "three";
import { RendererUtils } from "../RendererUtils";
/**
 * Performs a render pass that copies a texture into a RenderTarget by rendering with a fullscreen quad
 */
export class FullscreenQuadCopyPass {
    constructor(src, dst, options = {}) {
        let composite;
        if (typeof options !== "undefined") {
            if (typeof options.composite === "boolean") {
                composite = options.composite;
            }
            else {
                composite = false;
            }
        }
        else {
            composite = false;
        }
        const material = new MeshBasicMaterial({
            map: src,
            transparent: composite,
        });
        this.mesh = new Mesh(RendererUtils.FULLSCREEN_QUAD, material);
        this.dst = dst;
    }
    render(threeRenderer, webGLRenderer, camera, scene) {
        // Copy the output of the main scene rendering to the canvas buffer
        webGLRenderer.setRenderTarget(this.dst);
        webGLRenderer.render(this.mesh, RendererUtils.UNIT_ORTHOGRAPHIC);
    }
}
